import React from 'react';

function ReadmePage() {
  const styles = {
    container: {
      padding: 'var(--space-6)',
      maxWidth: '900px',
      margin: '0 auto',
    },
    title: {
      fontSize: 'var(--font-size-2xl)',
      fontWeight: 'var(--font-weight-bold)',
      marginBottom: 'var(--space-3)',
      color: 'var(--color-text-primary)',
      letterSpacing: '-0.025em',
    },
    intro: {
      fontSize: 'var(--font-size-sm)',
      color: 'var(--color-text-secondary)',
      marginBottom: 'var(--space-6)',
      lineHeight: 1.6,
    },
    section: {
      backgroundColor: 'var(--color-bg-base)',
      borderRadius: 'var(--radius-lg)',
      padding: 'var(--space-6)',
      marginBottom: 'var(--space-4)',
      boxShadow: 'var(--shadow-sm)',
      border: '1px solid var(--color-border-light)',
    },
    sectionTitle: {
      fontSize: 'var(--font-size-lg)',
      fontWeight: 'var(--font-weight-semibold)',
      marginBottom: 'var(--space-3)',
      color: 'var(--color-text-primary)',
    },
    row: {
      marginBottom: 'var(--space-2)',
      fontSize: 'var(--font-size-sm)',
      lineHeight: 1.6,
      color: 'var(--color-text-secondary)',
    },
    label: {
      fontWeight: '600',
      color: 'var(--color-text-primary)',
    },
    footer: {
      marginTop: 'var(--space-6)',
      fontSize: 'var(--font-size-xs)',
      color: 'var(--color-text-tertiary)',
      lineHeight: 1.6,
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Readme</h2>
      <div style={styles.intro}>
        This app supports multiple ways to add expenses. Pick the method that best matches your workflow—each option ends up in your Expenses list and analytics.
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>1) Manual entry</div>
        <div style={styles.row}><span style={styles.label}>Best for:</span> Cash purchases, quick one-off expenses, or when you don’t have a receipt.</div>
        <div style={styles.row}><span style={styles.label}>How it works:</span> You enter the merchant, amount, date, and optional notes/categories.</div>
        <div style={styles.row}><span style={styles.label}>Tip:</span> Use this when you want maximum control and speed.</div>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>2) Upload Receipt</div>
        <div style={styles.row}><span style={styles.label}>Best for:</span> Physical receipts, screenshots, and invoices.</div>
        <div style={styles.row}><span style={styles.label}>How it works:</span> Upload an image/PDF → AI extracts merchant/date/total (and line items when available) → expense is created automatically.</div>
        <div style={styles.row}><span style={styles.label}>Tip:</span> Clear, well-lit receipts improve accuracy.</div>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>3) Bank Statement</div>
        <div style={styles.row}><span style={styles.label}>Best for:</span> Bulk imports from your bank or credit card.</div>
        <div style={styles.row}><span style={styles.label}>How it works:</span> Upload a statement PDF → AI extracts transactions → multiple expenses are created in one go.</div>
        <div style={styles.row}><span style={styles.label}>Tip:</span> Use this for backfilling historical spending.</div>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>4) Telegram</div>
        <div style={styles.row}><span style={styles.label}>Best for:</span> Adding expenses on the go and chatting with your expense history.</div>
        <div style={styles.row}><span style={styles.label}>How it works:</span> Link Telegram in Settings → send messages like “Spent $5 on coffee” or upload a receipt/statement → the bot creates expenses.</div>
        <div style={styles.row}><span style={styles.label}>Tip:</span> Use Telegram for quick capture and questions like “When did I last buy X?”</div>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>5) Email forward</div>
        <div style={styles.row}><span style={styles.label}>Best for:</span> Online orders, subscription invoices, and transactions that are always recorded via email.</div>
        <div style={styles.row}><span style={styles.label}>How it works:</span> Forward receipt/transaction emails to your personal app mailbox → AI extracts date/merchant/amount → expense is created automatically.</div>
        <div style={styles.row}><span style={styles.label}>Use case:</span> If you receive instant email notifications for PayLah / PayNow / bank transfers, you can forward those emails so every transaction is captured automatically without manual entry.</div>
        <div style={styles.row}><span style={styles.label}>Note:</span> You’ll need to set up forwarding rules in your email provider.</div>
      </div>

      <div style={styles.footer}>
        If something looks wrong, you can always edit the expense afterward from the Expenses page.
      </div>
    </div>
  );
}

export default ReadmePage;

